import Route from '@ember/routing/route';
import JournalReportIntervarsity from 'donor-elf-web/lib/models/journal-report-intervarsity';
import { service } from '@ember/service';
import Store from '@ember-data/store';
import JournalDashboardModel from 'donor-elf-web/models/journal-dashboard';
import GoalModel from 'donor-elf-web/models/goal';
import { type JournalReportRouteModel } from '../report';

export interface JournalIntervarsityReportRouteModel
  extends JournalReportRouteModel {
  reportIntervarsity: JournalReportIntervarsity;
  journalContactInfos: any[];
  journalDashboard: JournalDashboardModel;
  goal: GoalModel;
}

export default class JournalIntervarsityReportRoute extends Route {
  @service declare formatDateService: any;
  @service declare fundsService: any;
  @service declare journalService: any;
  @service declare store: Store;

  async model() {
    let reportModel = this.modelFor(
      'funds.fund.journals.journal.report',
    ) as JournalReportRouteModel;
    let journalContactInfos = await this.journalService.loadJournalContactInfos(
      reportModel.journalInfo.journal.id,
    );
    let reportIntervarsity = new JournalReportIntervarsity({
      journalInfo: reportModel.journalInfo,
      journalReport: reportModel.journalReport,
      formatDateService: this.formatDateService,
      journalContactInfos,
    });
    let journalDashboard = (
      await this.store.query('journal-dashboard', {
        filter: { journal_ids: reportModel.journalInfo.journal.id },
      })
    ).slice()[0];
    let goal = await this.store.findRecord(
      'goal',
      this.fundsService.selectedFund.id,
      { reload: true },
    );

    return {
      ...reportModel,
      reportIntervarsity,
      journalContactInfos,
      journalDashboard,
      goal,
    };
  }
}
